import { render, staticRenderFns } from "./AdmCreditCards.vue?vue&type=template&id=504033b8&scoped=true"
import script from "./AdmCreditCards.vue?vue&type=script&lang=js"
export * from "./AdmCreditCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504033b8",
  null
  
)

export default component.exports